module.exports = __webpack_public_path__ + "img/image.bca7e294.svg";